module.exports = __webpack_public_path__ + "static/media/IMG-14.7191ac75.jpg";